import React from "react";
import { styled } from "@mui/material/styles";
import { Card, Box, Tooltip, Stack, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import axios from "../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getOrgId } from "../../utils/Token";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";

import dayjs from 'dayjs';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FormControl from "@mui/material/FormControl";


import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, {
    accordionSummaryClasses,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import GetfVDateFormate from "../../utils/Genaricfunctions";
import Restore from "../../icons/Restore.svg";
import IconButton from "@mui/material/IconButton";
import Paginator from "../../toolkit/Paginator";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.action.hover,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
        marginBottom: "20px",
    },
}));
const StyledTableCell1 = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#2a93db2e",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
        marginBottom: "20px",
    },
}));



const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary

        {...props}
    />
))(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
        transform: 'rotate(90deg)',
    },
    [`& .${accordionSummaryClasses.content}`]: {
        marginLeft: theme.spacing(1),
    },
    ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255, 255, 255, .05)',
    }),
}));


const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function GenerateCode() {

    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    const [LocationsList, setLocationsList] = useState([]);
    const [spinner, setSpinner] = React.useState(false);
    const [From, setFrom] = React.useState(dayjs());
    const [To, setTo] = React.useState(dayjs().add(1, 'day'));
    const [MaxUsers, setMaxUsers] = React.useState('');
    const [StaticCodesList, setStaticCodesList] = useState([]);

    const OrgId = getOrgId();

    const SpinnerClose = () => {
        setSpinner(false);
    };

    useEffect(() => {
        Details();
    }, []);

    function Details() {
        setSpinner(true);
        axios.get("Companies/GetClientUserBusinessUnitSites?clientId=" + OrgId)
            .then(res => {
                setLocationsList(res?.data?.data?.item2);
            }).catch((error) => {
                console.log(error.response.data);
            }).finally(() => {
                setSpinner(false)
            });
    };

    const SendRequest = (val) => {
        window.open("/EmployeeCheckinCode?Id=" + val?.businessUnitSiteID + "&name=" + val?.businesUnitsiteName, '_blank');
        //navigate("/EmployeeCheckinCode?Id=" + val?.businessUnitSiteID + "&name=" + val?.businesUnitsiteName)
    }

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme?.breakpoints?.down("md"));

    const groupedData = LocationsList?.reduce((acc, curr) => {
        const clientKey = curr.clientName;
        const buKey = curr.businessUnitName;
        if (!acc[clientKey]) {
            acc[clientKey] = {};
        }
        if (!acc[clientKey][buKey]) {
            acc[clientKey][buKey] = [];
        }
        acc[clientKey][buKey].push(curr);
        return acc;
    }, {});

    const [showPrompt, setShowPrompt] = useState(false);
    const [showPrompt1, setShowPrompt1] = useState(false);
    const [Id, setId] = useState("");
    const [SName, setSName] = useState("");
    const [expandedRow, setExpandedRow] = React.useState(null);
    const [Dis, setDis] = useState(false);
    const [ButtonDis, setButtonDis] = useState(false);
    const [number, setNumber] = useState("1");
    const [Count, setCount] = useState("");
    const [CodeHistory, setCodeHistory] = useState([]);
    const [Checkincode, setCheckincode] = useState("");

    const handleRowClick = (val, n) => {
        if (n != 1) {
            setStaticCodesList([]);
        }
        setNumber("1");
        setId(val);
        if (n == 1) {
            setExpandedRow(val);
        } else {
            setExpandedRow((prev) => (prev === val ? null : val));
        }
        setSpinner(true);
        GetStaticCodes(val, "1");
    };
    const GetStaticCodes = (i, val) => {
        const PageNumber = val == "1" ? 1 : number;
        axios.get("OnsiteOffsite/GetSiteStaticCodes?pageNumber=" + PageNumber + "&pageSize=" + 12 + "&siteId=" + i)
            .then(res => {
                setStaticCodesList(res?.data?.data);
                setCount(res?.data?.count);
            }).catch((error) => {
                console.log(error.response.data);
            }).finally(() => {
                setSpinner(false);
                setDis(false);
            });
    }

    useEffect(() => {
        if (Dis == true) {
            GetStaticCodes(Id, "");
        }
    }, [Dis]);

    const GetHistory = (code) => {
        setCodeHistory([]);
        setShowPrompt1(true);
        setSpinner(true);
        setCheckincode(code);
        axios.get("OnsiteOffsite/GetStaticCodeHistory?code=" + code)
            .then(res => {
                setCodeHistory(res?.data?.data);
            }).catch((error) => {
                console.log(error.response.data);
            }).finally(() => {
                setSpinner(false);
            });
    }

    const setOpenShowPrompt = (r) => {
        setShowPrompt(true);
        //setId((prev) => (prev === r?.businessUnitSiteID ? null : r?.businessUnitSiteID));
        setId(r?.businessUnitSiteID)
        setSName(r?.businesUnitsiteName);
    }
    const handleDateKeyDown = (e) => {
        e.preventDefault();
    };


    const handlePageChange = (event) => {
        setNumber(event);
        setDis(true);
    };

    const SaveStaticCode = () => {
        setButtonDis(true);
        if (!MaxUsers) {
            toastNotify("Please enter mandatory fields!", false);
            setButtonDis(false);
        } else {
            if (To > From) {
                const data = {
                    "validFrom": From,
                    "validTo": To,
                    "maxUses": MaxUsers,
                    "checkinsUsed": 0,
                    "siteId": Id,
                    "clientId": OrgId
                }
                setSpinner(true);
                axios.post("OnsiteOffsite/GenerateSiteStaticCheckinCode", data
                ).then((res) => {
                    if (res?.data?.data == "Success") {
                        toastNotify(res?.data?.data, true);
                        setNumber("1");
                        handleRowClick(Id, 1);
                        setShowPrompt(false);
                        setMaxUsers("");
                        setFrom(dayjs());
                        setTo(dayjs().add(1, 'day'));
                    } else {
                        toastNotify(res?.data?.responseMessage, false);
                        setShowPrompt(true);
                    }
                }).finally(() => {
                    setSpinner(false);
                    setButtonDis(false);
                })
            } else {
                toastNotify("(Valid To) should be greater than (Valid From)", false);
                setButtonDis(false);
            }
        }
    }

    return (
        <React.Fragment>

            <ToastContainer />

            <Dialog
                fullScreen={fullScreen}
                open={showPrompt}
                disableBackdropClick="true"
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        setShowPrompt(false)
                    }
                }}
            >
                <DialogContent
                    sx={{ padding: "40px 48px", overflowX: "hidden" }}
                    className="pb-1"
                >
                    <span className='mx-2'
                        onClick={() => {
                            setShowPrompt(false);
                        }} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        Site name: {SName}
                    </DialogTitle>



                    <FormControl sx={{ m: 1, width: "100%" }}>
                        <span style={{ color: "#3E4A62", fontSize: "15px" }} className="username-label mt-2">
                            Valid From: <span className="red-color">*</span>
                        </span>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                views={["year", "month", "day"]}
                                value={From}
                                name="toDate"
                                onChange={(e) => {
                                    setFrom(e);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "100%",
                                        }}
                                        name="toDate"
                                        size="small"
                                        onKeyDown={handleDateKeyDown}
                                    />
                                )}
                            />
                        </LocalizationProvider>

                    </FormControl>

                    <FormControl sx={{ m: 1, width: "100%" }}>
                        <span style={{ color: "#3E4A62", fontSize: "15px" }} className="username-label mt-2">
                            Valid Thru: <span className="red-color">*</span>
                        </span>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                views={["year", "month", "day"]}
                                value={To}
                                name="Thru"
                                onChange={(e) => {
                                    setTo(e);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "100%",
                                        }}
                                        name="Thru"
                                        size="small"
                                        onKeyDown={handleDateKeyDown}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </FormControl>
                    <FormControl sx={{ m: 1, width: "100%" }}>
                        <span style={{ color: "#3E4A62", fontSize: "15px" }} className="username-label mt-2">
                            Max uses: <span className="red-color">*</span>
                        </span>
                        <TextField
                            className="form-control  "
                            placeholder='Max uses'
                            id="Max uses"
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                width: "100%",
                            }}
                            size="small"
                            type="number"
                            value={MaxUsers}
                            required
                            onChange={(e) => {
                                if (e.target.value > 0) {
                                    setMaxUsers(e.target.value);
                                } else {
                                    setMaxUsers("");
                                }
                            }}
                        />

                    </FormControl>

                </DialogContent>
                <DialogActions className="pb-5">
                    <div className="login-help__buttonContainer d-flex gap-5 align-items-center px-5 mx-2">
                        <Button
                            variant="contained"
                            className="login-help-button-cancel mx-2"
                            onClick={() => {
                                setShowPrompt(false);
                                setMaxUsers("");
                                setFrom(dayjs());
                                setTo(dayjs().add(1, 'day'));
                                setButtonDis(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            className="login-button-request mx-2"
                            onClick={SaveStaticCode}
                            disabled={ButtonDis}
                        >
                            Ok
                        </Button>
                    </div>
                </DialogActions>

            </Dialog>

            <Dialog
                fullScreen={fullScreen}
                open={showPrompt1}
                disableBackdropClick="true"
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        setShowPrompt1(false)
                    }
                }}
            >
                <DialogContent
                    //sx={{ padding: "40px 48px", overflowX: "hidden" }}
                    className="pb-10"
                >
                    <span className='mx-2'
                        onClick={() => {
                            setShowPrompt1(false);
                        }} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        <span style={{ textAlign: "center", width: "max-content" }}>Site name: {SName}</span>
                    </DialogTitle>
                    {CodeHistory?.length < 1 ?
                        <div hidden={spinner}>
                            <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, width: "auto" }} className="text-center">
                                <span style={{ color: "#667085" }}>No Result Found</span>
                            </Box>
                        </div> :
                        <>
                            <TableContainer component={Paper} className="mb-3">
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: "#F2F4F7", color: "#667085" }}>
                                            <TableCell style={{ fontSize: "13px", color: "#667085", textAlign: "center" }}>Check-in Code</TableCell>
                                            <TableCell style={{ fontSize: "13px", color: "#667085", textAlign: "center" }}>Used By</TableCell>
                                            <TableCell style={{ fontSize: "13px", color: "#667085", textAlign: "center" }}>Used On</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {CodeHistory?.map((r, i) => (
                                            <TableRow
                                                key={i}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell style={{ fontSize: "13px", textAlign: "center" }}>{Checkincode}</TableCell>
                                                <TableCell style={{ fontSize: "13px", textAlign: "center" }}>{r?.employeeName}</TableCell>
                                                <TableCell style={{ fontSize: "13px", textAlign: "center" }}>{GetfVDateFormate(r?.checkinDate)}</TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>}
                </DialogContent>
            </Dialog>

            <Box sx={{ margin: 1 }}>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={spinner}
                    onClick={SpinnerClose}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>

                <Box sx={{ margin: 1 }}>

                    {LocationsList?.length < 1 ?
                        <div hidden={spinner}>
                            <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, width: "auto" }} className="text-center">
                                <span style={{ color: "#667085" }}>No Result Found</span>
                            </Box>
                        </div> :
                        <>
                            {(Object.entries(groupedData)?.map(([clientName, clientData]) => (


                                <Box sx={{ backgroundColor: "#f8f9fa" }}>
                                    <TableContainer
                                        component={Paper}
                                        key={"ss" + clientName}
                                        sx={{ borderBottom: 0 }}
                                    >
                                        <Table aria-label="customized table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell>
                                                        <Typography variant="h5" gutterBottom component="div">
                                                            Site Name
                                                        </Typography>
                                                    </StyledTableCell>
                                                </TableRow>
                                            </TableHead>

                                            {Object.entries(clientData)?.map(([buName, buData]) => (
                                                <>
                                                    <TableHead key={buName}>
                                                        <TableRow>
                                                            <StyledTableCell1>
                                                                <Typography variant="h6" gutterBottom component="div">
                                                                    {buName}
                                                                </Typography>
                                                            </StyledTableCell1>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {buData?.map((r, i) => (
                                                            <AccordionDetails sx={{ padding: "0px" }}>
                                                                <Accordion key={i} expanded={expandedRow == r?.businessUnitSiteID} >
                                                                    <AccordionSummary expandIcon={<ArrowForwardIosSharpIcon onClick={() => { setSName(r?.businesUnitsiteName); handleRowClick(r?.businessUnitSiteID, ""); }} sx={{ fontSize: '0.9rem' }} />} aria-controls="panel1d-content" id="panel1d-header" >
                                                                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                                                                            <Typography onClick={() => { setSName(r?.businesUnitsiteName); handleRowClick(r?.businessUnitSiteID, ""); }}> {r?.businesUnitsiteName}</Typography>
                                                                            <div style={{ gap: "10px", display: "flex" }}>
                                                                                <Button variant="contained" disabled={r?.isComplianceCheckinRequired != true} sx={{ padding: "15px", textTransform: "none", width: "max-content" }}
                                                                                    onClick={() => {
                                                                                        setOpenShowPrompt(r);

                                                                                    }}> Generate static code</Button>
                                                                                <Button variant="contained" disabled={r?.isComplianceCheckinRequired != true} sx={{ padding: "15px", textTransform: "none", width: "max-content" }}
                                                                                    onClick={() => {
                                                                                        SendRequest(r);

                                                                                    }}>Generate one-time code</Button>
                                                                            </div>
                                                                        </div>
                                                                    </AccordionSummary>
                                                                    <AccordionDetails>
                                                                        {StaticCodesList?.length < 1 ?
                                                                            <div hidden={spinner}>
                                                                                <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, width: "auto" }} className="text-center">
                                                                                    <span style={{ color: "#667085" }}>No Result Found</span>
                                                                                </Box>
                                                                            </div> :
                                                                            <>
                                                                                <TableContainer component={Paper}>
                                                                                    <Table aria-label="simple table">
                                                                                        <TableHead>
                                                                                            <TableRow sx={{ backgroundColor: "#F2F4F7", color: "#667085" }}>
                                                                                                <TableCell style={{ fontSize: "13px", color: "#667085", textAlign: "center" }}>Check-in Code</TableCell>
                                                                                                <TableCell style={{ fontSize: "13px", color: "#667085", textAlign: "center" }}>Valid From</TableCell>
                                                                                                <TableCell style={{ fontSize: "13px", color: "#667085", textAlign: "center" }}>Valid Thru</TableCell>
                                                                                                <TableCell style={{ fontSize: "13px", color: "#667085", textAlign: "center" }}>Max. Uses </TableCell>
                                                                                                <TableCell style={{ fontSize: "13px", color: "#667085", textAlign: "center" }}>Check-in(s) Used</TableCell>
                                                                                                <TableCell style={{ fontSize: "13px", color: "#667085" }}></TableCell>
                                                                                            </TableRow>
                                                                                        </TableHead>
                                                                                        <TableBody>
                                                                                            {StaticCodesList?.map((row) => (
                                                                                                <TableRow
                                                                                                    key={row.modifiedOn}
                                                                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                                                >
                                                                                                    <TableCell style={{ fontSize: "13px", textAlign: "center" }}>{row?.checkinCode}</TableCell>
                                                                                                    <TableCell style={{ fontSize: "13px", textAlign: "center" }}>{GetfVDateFormate(row?.validFrom) + " 12:00 AM"}</TableCell>
                                                                                                    <TableCell style={{ fontSize: "13px", textAlign: "center" }}>{GetfVDateFormate(row?.validTo) + " 11:59 PM"}</TableCell>
                                                                                                    <TableCell style={{ fontSize: "13px", textAlign: "center" }}>{row?.maxUses}</TableCell>
                                                                                                    <TableCell style={{ fontSize: "13px", textAlign: "center" }}>{row?.checkinsUsed}</TableCell>
                                                                                                    <TableCell style={{ fontSize: "13px" }}>
                                                                                                        <IconButton
                                                                                                            aria-label="Restore"
                                                                                                            onClick={() => {
                                                                                                                GetHistory(row?.checkinCode);
                                                                                                            }}
                                                                                                        >
                                                                                                            <img
                                                                                                                src={Restore}
                                                                                                                alt="Restoreicon"
                                                                                                                style={{ width: "25px" }}
                                                                                                            />
                                                                                                        </IconButton>
                                                                                                    </TableCell>

                                                                                                </TableRow>
                                                                                            ))}
                                                                                        </TableBody>
                                                                                    </Table>
                                                                                </TableContainer>

                                                                                <div hidden={StaticCodesList?.length < 1}>
                                                                                    <Paginator
                                                                                        count={Math.ceil(Count / 12)}
                                                                                        page={Number(number)}
                                                                                        margin="18px 0px"
                                                                                        onChange={handlePageChange}
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </AccordionDetails>
                                                                </Accordion>
                                                            </AccordionDetails>


                                                        ))}
                                                    </TableBody >
                                                </>
                                            ))}

                                        </Table>
                                    </TableContainer >
                                </Box>


                            )))}
                        </>
                    }
                </Box>

            </Box>
        </React.Fragment >
    );
}

